/* eslint-disable import/prefer-default-export */
import { useMutation, useQuery /* , useQueryClient */ } from 'react-query'
import {
  getAverageAmountsPerYearAndMonth,
  getYearPrograms,
  getTotalProgramsPerStateAndZoneAndMonthAndYear,
  generateResolutionOfRequestsReport,
  getAmountApprovedPerBenefit,
  generateAmountApprovedPerBenefitReport,
  getRequestsApprovedPerGrade,
  generateApprovedPerGradeReport,
  getRequestsApprovedPerBeneficiary,
  generateRequestApprovedPerBeneficiaryReport
} from '../api/Reportability'

const key = 'reportability'

const getAction = (type) => {
  if (type === 'GENERATE-RESOLUTION-OF-REQUESTS-REPORT')
    return generateResolutionOfRequestsReport
  if (type === 'GENERATE-AMOUNT-APPROVED-PER-GRADE-YEAR-ZONE-TYPE')
    return generateAmountApprovedPerBenefitReport
  if (type === 'GENERATE-APPOVED-PER-GRADE-REPORT')
    return generateApprovedPerGradeReport
  if (type === 'GENERATE-REQUEST-APPROVED-PER-BENEFICIARY')
    return generateRequestApprovedPerBeneficiaryReport
  return null
}

export function useReportability(type, filters) {
  const queryFn = () => {
    if (type === 'AVG-YEAR-MONTH') return getAverageAmountsPerYearAndMonth(filters)
    if (type === 'YEARS-PROGRAMS') return getYearPrograms(filters)
    if (type === 'TOTAL-PROGRAMS-PER-STATE-ZONE-YEAR-MONTH') return getTotalProgramsPerStateAndZoneAndMonthAndYear(filters)
    if (type === 'AMOUNT-APPROVED-PER-GRADE-YEAR-ZONE-TYPE') return getAmountApprovedPerBenefit(filters)
    if (type === 'REQUESTS-APPOVED-PER-GRADE-ZONE-YEAR-MONTH') return getRequestsApprovedPerGrade(filters)
    if (type === 'REQUEST-APPROVED-PER-BENEFICIARY') return getRequestsApprovedPerBeneficiary(filters)
    return null
  }

  return useQuery([`${key}/${type}`, filters], queryFn, {
    refetchOnWindowFocus: false
  })
}

export function useMutateReportability(type) {
  const actionFn = getAction(type)
  return useMutation(actionFn, {
    onSuccess: () => {
      /* queryClient.invalidateQueries([key]) */
    }
  })
}
